import SEO from "@components/SEO/SEO.component";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import ScrollTopOnPageChange from "./../components/ScrollTopOnPageChange/ScrollTop.component";
import FloatingCoverMenu from "./FloatingCoverMenu";
import FloatingLogo from "./FloatingLogo";
import Footer from "./Footer";
import GlobalStyle from "./GlobalStyle";
import Header from "./Header";
import NavigationStatic, { NavigationMenuFloating } from "./Navigation";
import SiteIsNotBeingUsedInfo from "./SiteNotBeingUsedInfo";

const Container = styled.div`
    position: relative;
    width: 70%;
    max-width: 1170px;
    min-width: 1170px;
    min-height: 80vh;
    margin: 150px auto 100px;
    padding: 50px 80px 100px;
    background-color: ${({ theme }) => theme.colors.white};

    @media screen and (max-width: 1250px) {
        min-width: 960px;
    }

    @media screen and (max-width: 1050px) {
        min-width: 750px;
        padding: 100px 80px;
    }

    @media screen and (max-width: 830px) {
        min-width: unset;
        padding: 80px 0px;
        margin: 0px auto;
        width: 100%;
    }
`;

const LayoutComponent = React.forwardRef(({ children }, ref) => {
    const location = useLocation();
    const [isMainPage, setIsMainPage] = useState(true);

    useEffect(() => {
        if (location.pathname !== "/") {
            setIsMainPage(false);
        } else {
            setIsMainPage(true);
        }
    }, [location.pathname]);

    return (
        <SEO
            title="Magazyn Zdrowe Dziecko"
            description="Strona magazynu 'Zdrowe Dziecko' - magazyn dla rodziców."
        >
            <ScrollTopOnPageChange />
            <GlobalStyle />
            <Container ref={ref}>
                <NavigationStatic inverted={!isMainPage} />
                <NavigationMenuFloating />
                <Header shouldShow={isMainPage} />
                <FloatingLogo shouldShow={!isMainPage} />
                <FloatingCoverMenu />
                {children}
            </Container>
            <SiteIsNotBeingUsedInfo>
                Ta strona nie jest już dostępna lub aktywna. Służy wyłącznie do
                celów prezentacyjnych!
            </SiteIsNotBeingUsedInfo>
            <Footer />
        </SEO>
    );
});

export default LayoutComponent;
